import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import NavigationHeaderEPC from "../../components/Cse/NavigationHeaderEPC";
import CustomerManager from "../../components/Cse/CustomerManager";
import EPCQuotations from "../../components/Cse/EpcQuotation";
import { AllSalesRepInfo } from "../../components/Cse/AllSalesRepInfo";
import CommissionsTable from "../../components/CommissionAndRepayment/CommissionTable";
import PaymentsTable from "../../components/Cse/PaymentsTable";
import RepaymentsTable from "../../components/CommissionAndRepayment/RepaymentsTable";
import { IStatusCycle } from "../../models/commissionAndRepayment.model";

export enum ICseDashboardTab {
  Customers = "customers",
  Quotations = "quotations",
  SalesRep = "Sales-rep",
  Commissions = "commissions",
  Payments = "payments",
  RePayments = "rePayments",
}

const CseDashboard: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabFromUrl = searchParams.get("tab") as ICseDashboardTab | null;

  const activeTab = Object.values(ICseDashboardTab).includes(
    tabFromUrl as ICseDashboardTab,
  )
    ? (tabFromUrl as ICseDashboardTab)
    : ICseDashboardTab.Customers;

  const handleTabChange = (tab: ICseDashboardTab) => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set("tab", tab);
      return params;
    });
  };

  const [repaymentStatus, setRepaymentStatus] = useState<string>(
    IStatusCycle.PENDING,
  );

  const renderContent = () => {
    switch (activeTab) {
      case ICseDashboardTab.Customers:
        return <CustomerManager />;
      case ICseDashboardTab.Quotations:
        return <EPCQuotations />;
      case ICseDashboardTab.SalesRep:
        return <AllSalesRepInfo />;
      case ICseDashboardTab.Commissions:
        return <CommissionsTable />;
      case ICseDashboardTab.RePayments:
        return <RepaymentsTable repaymentStatus={repaymentStatus} from="cse" />;
      case ICseDashboardTab.Payments:
        return <PaymentsTable />;
      default:
        return <CustomerManager />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <NavigationHeaderEPC
        activeTab={activeTab}
        onTabChange={handleTabChange}
        repaymentStatus={repaymentStatus}
        setRepaymentStatus={setRepaymentStatus}
      />

      <div className="mx-auto">{renderContent()}</div>
    </div>
  );
};

export default CseDashboard;
